export const MODALS = {
	NEW_EXPERIMENT: "NEW_EXPERIMENT",
	START_EXPERIMENT: "START_EXPERIMENT",
	END_EXPERIMENT: "END_EXPERIMENT",
	REMOVE_EXPERIMENT: "REMOVE_EXPERIMENT",
	RESET_EXPERIMENT: "RESET_EXPERIMENT",
};

export const MODAL_TITLES = {
	[MODALS.NEW_EXPERIMENT]: "Create an experiment",
	[MODALS.START_EXPERIMENT]: "Start an experiment",
	[MODALS.END_EXPERIMENT]: "End an experiment",
	[MODALS.REMOVE_EXPERIMENT]: "Remove an experiment",
	[MODALS.RESET_EXPERIMENT]: "Version an experiment",
};

export const MAX_GROUPS = 3;

export const STATUSES = {
	SUCCESS: 0, // all is well
	TRACKED: 1, // user is tracked for given experiment
	UNTRACKED: 2, // user is not yet tracked for given experiment
	INVALID_INPUT: 3, // passed inputs failed validation
	NOT_FOUND: 4, // given id for experiment/group not found
};

export const SORTS = {
	NAME_ASC: "NAME_ASC",
	NAME_DESC: "NAME_DESC",
	LONGEST_RUNNING: "LONGEST_RUNNING",
};

export const SORT_OPTIONS = [
	{
		value: SORTS.NAME_ASC,
		name: "Name (ascending)",
	},
	{
		value: SORTS.NAME_DESC,
		name: "Name (descending)",
	},
	{
		value: SORTS.LONGEST_RUNNING,
		name: "Longest running",
	},
];



// WEBPACK FOOTER //
// ./src/apps/experiments/util/constants.js